import { SVGProps } from 'react';

const HelpIcon = (props: SVGProps<SVGSVGElement> & { iconColor?: string }) => {
  const { iconColor, ...rest } = props;
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M7.00002 1.75C3.78228 1.75 1.16669 4.3656 1.16669 7.58333V8.63333C1.16669 9.64946 1.88926 10.4962 2.84519 10.6957C3.23281 11.7495 4.24894 12.4758 5.40056 12.4758H7.00002C7.31239 12.4758 7.56454 12.2236 7.56454 11.9113C7.56454 11.6027 7.31239 11.3468 7.00002 11.3468H5.40056C4.90001 11.3468 4.4484 11.1134 4.15109 10.7409H4.30164C4.61399 10.7409 4.86615 10.4887 4.86615 10.1763V7.09032C4.86615 6.77795 4.61399 6.52581 4.30164 6.52581H3.27421C2.95432 6.52581 2.64949 6.60108 2.37851 6.72902C2.7812 4.54247 4.69679 2.87903 7.00002 2.87903C9.30325 2.87903 11.2188 4.54247 11.6215 6.72902C11.3506 6.60108 11.0457 6.52581 10.7258 6.52581H9.6984C9.38605 6.52581 9.13388 6.77795 9.13388 7.09032V10.1763C9.13388 10.4887 9.38605 10.7409 9.6984 10.7409H10.7258C11.8887 10.7409 12.8334 9.79624 12.8334 8.63332V7.58333C12.8334 4.3656 10.2178 1.75 7.00002 1.75Z'
        fill={iconColor || '#F69539'}
      />
    </svg>
  );
};

export default HelpIcon;
